module.exports = __webpack_public_path__ + "img/business.6254dd79.png";